import React from "react";

const WhatsAppIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
      fill="#25D366"
    />
  </svg>
);

const FacebookIcon = ({ size = 16, className = "", color }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
      fill={color || (className.includes("fill-current") || className.includes("text-") ? "currentColor" : "#1877F2")}
    />
  </svg>
);

const InstagramIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#fdf497" />
        <stop offset="5%" stopColor="#fdf497" />
        <stop offset="45%" stopColor="#fd5949" />
        <stop offset="60%" stopColor="#d6249f" />
        <stop offset="90%" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-grad)" />
    <path
      d="M12 7.5A4.5 4.5 0 107.5 12 4.505 4.505 0 0012 7.5zm0 7.5a3 3 0 110-6 3 3 0 010 6zm5.884-7.685a1.05 1.05 0 11-1.05-1.05 1.05 1.05 0 011.05 1.05zM19.5 12c0-2.07.018-2.31-.03-3.378a5.97 5.97 0 00-1.593-4.2 6.003 6.003 0 00-4.2-1.593C12.61 2.782 12.37 2.8 10.3 2.8s-2.31-.018-3.378.03a5.97 5.97 0 00-4.2 1.593 6.003 6.003 0 00-1.593 4.2C1.082 9.69 1.1 9.93 1.1 12s-.018 2.31.03 3.378a5.97 5.97 0 001.593 4.2 6.003 6.003 0 004.2 1.593C7.99 21.218 8.23 21.2 10.3 21.2s2.31.018 3.378-.03a5.97 5.97 0 004.2-1.593 6.003 6.003 0 001.593-4.2c.047-1.068.029-1.308.029-3.377zm-1.499 3.31a4.48 4.48 0 01-2.525 2.525c-1.748.694-5.896.534-7.826.534s-6.083.157-7.826-.534A4.48 4.48 0 01-.7 15.31C-1.394 13.562-1.234 9.414-1.234 7.484S-1.39 1.4-.7-.348A4.48 4.48 0 011.824-2.874C3.572-3.568 7.72-3.408 9.65-3.408s6.083-.157 7.826.534a4.48 4.48 0 012.525 2.525c.694 1.748.534 5.896.534 7.826s.16 6.083-.534 7.833z"
      fill="white"
    />
  </svg>
);

// Simpler, cleaner Instagram icon
const InstagramIconClean = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="ig-linear" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#FFDC80" />
        <stop offset="25%" stopColor="#FCAF45" />
        <stop offset="50%" stopColor="#F77737" />
        <stop offset="75%" stopColor="#C13584" />
        <stop offset="100%" stopColor="#833AB4" />
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-linear)" />
    <circle cx="12" cy="12" r="4.5" stroke="white" strokeWidth="1.8" fill="none" />
    <circle cx="17.2" cy="6.8" r="1.1" fill="white" />
  </svg>
);

const CHANNEL_CONFIG = {
  whatsapp: {
    icon: WhatsAppIcon,
    label: "WhatsApp",
    color: "#25D366",
    bg: "bg-emerald-50 dark:bg-emerald-900/20",
    text: "text-emerald-700 dark:text-emerald-400"
  },
  whatsapp_cloud: {
    icon: WhatsAppIcon,
    label: "WhatsApp Cloud",
    color: "#075E54",
    bg: "bg-emerald-100 dark:bg-emerald-950/40",
    text: "text-emerald-800 dark:text-emerald-300"
  },
  whatsapp_coexistence: {
    icon: WhatsAppIcon,
    label: "WhatsApp Coexistencia",
    color: "#a855f7",
    bg: "bg-purple-50 dark:bg-purple-900/20",
    text: "text-purple-700 dark:text-purple-400"
  },
  facebook: {
    icon: FacebookIcon,
    label: "Facebook",
    color: "#1877F2",
    bg: "bg-blue-50 dark:bg-blue-900/20",
    text: "text-blue-700 dark:text-blue-400"
  },
  instagram: {
    icon: InstagramIconClean,
    label: "Instagram",
    color: "#C13584",
    bg: "bg-pink-50 dark:bg-pink-900/20",
    text: "text-pink-700 dark:text-pink-400"
  }
};

/**
 * Renders the icon for a given channel type.
 * channel: "whatsapp" | "facebook" | "instagram"
 * size: icon size in px
 * showLabel: whether to show the channel name next to the icon
 * badge: renders as a small badge (icon + optional label in a pill)
 */
const ChannelIcon = ({ channel = "whatsapp", size = 16, showLabel = false, badge = false }) => {
  const cfg = CHANNEL_CONFIG[channel] || CHANNEL_CONFIG.whatsapp;
  const Icon = cfg.icon;

  if (badge) {
    return (
      <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${cfg.bg} ${cfg.text}`}>
        <Icon size={size} />
        {showLabel && <span>{cfg.label}</span>}
      </span>
    );
  }

  if (showLabel) {
    return (
      <span className="inline-flex items-center gap-1.5">
        <Icon size={size} />
        <span className={`text-xs font-medium ${cfg.text}`}>{cfg.label}</span>
      </span>
    );
  }

  return <Icon size={size} />;
};

export { CHANNEL_CONFIG, FacebookIcon, WhatsAppIcon, InstagramIcon };
export default ChannelIcon;
